import SecondaryPhotosView from './SecondaryPhotosView';

export default SecondaryPhotosView;
